import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, Container, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import PastAssignments from '../../components/ContentComponents/PastAssignments/PastAssignments';
import ActiveAssignmentsYourTeam from '../../components/ContentComponents/ActiveAssignments/ActiveAssignmentsYourTeam';
import UpcomingAssignmentsYourTeam from '../../components/ContentComponents/UpcomingAssignments/UpcomingAssignmentsYourTeam';
import PresentsList from '../../components/ContentComponents/PresentsList/PresentsList';
import { COLORS } from '../../utils/Application_Constants';
import { WithContexts } from '../../contexts/withContexts';
import ErrorDialog from '../../components/GlobalComponents/Dialog/ErrorDialog';

const styles = (theme) => ({
    root: {
        backgroundColor: COLORS.BLACK_HAZE,
        minHeight: '800px',
        paddingBottom: '25px',
        [theme.breakpoints.down('md')]: {
            paddingTop: '32px',
        },
    },
    progressWrapper: {
        height: '80vh',
    },
    progressRoot: {
        marginTop: '25vh',
    },
    indicator: {
        backgroundColor: COLORS.DENIM,
        opacity: '1',
    },
    tabsRoot: {
        color: COLORS.SLATE_GRAY,
        paddingBottom: '25px',
        [theme.breakpoints.up('md')]: {
            padding: '26px 88px',
        },
    },
    Tab_Root: {
        minWidth: '95px',
    },
    scrollableVariant: {
        '-ms-overflow-style': 'none',
    },
});

class Assignments extends Component {
    constructor(props) {
        super(props);
        const { PageContext: { setPageName } = {} } = this.props;
        setPageName('Assignments');
        this.state = {
            currentlyActiveTab: 0,
            isLoading: true,
            url: {
                location: 'active',
                id: null,
            },
            flags: {
                isLoading: false,
                dataSaved: false,
                isDirty: false,
                showSaveChanges: false,
                isPendingSave: false,
                targetTab: 0,
                validationError: false,
                navDisabled: false,
                apiError: '',
                errorMessage: '',
            },
        };
    }

    async componentDidMount() {
        await this.getUrlParams();
        await this.setTabState();
    }

    async componentDidUpdate(prevProps) {
        const { match } = this.props;
        if (prevProps.match.params.status !== match.params.status) {
            await this.getUrlParams();
            this.setState({
                currentlyActiveTab: this.getLocationIndexByStatus(match.params.status),
            });
        }
    }

    setAssignmentPageError = (e) => {
        const { flags } = { ...this.state };
        if (
            Object.prototype.hasOwnProperty.call(e, 'title') &&
            Object.prototype.hasOwnProperty.call(e, 'message')
        ) {
            flags.apiError = e;
        } else {
            flags.errorMessage = 'Error loading page';
        }
        flags.isLoading = false;
        flags.isPendingSave = false;
        this.setState({ flags });
    };

    getUrlParams() {
        const { match } = this.props;
        this.setState({ url: { ...match.params } });
    }

    getLocationIndexByStatus(status) {
        switch (status) {
            case 'active':
                return 0;
            case 'upcoming':
                return 1;
            case 'past':
                return 2;
            case 'presents':
                return 3;
            default:
                return 0;
        }
    }

    getLocationByIndex(currentIndex) {
        switch (currentIndex) {
            case 0:
                return 'active';
            case 1:
                return 'upcoming';
            case 2:
                return 'past';
            case 3:
                return 'presents';
            default:
                return 'active';
        }
    }

    closeError = () => {
        const state = { ...this.state };
        state.flags.apiError = null;
        this.setState({ ...state });
    };

    tabChanged = async (event, newValue) => {
        const { history } = this.props;
        history.push(`/assignments/${this.getLocationByIndex(newValue)}`);
        await this.setState({ currentlyActiveTab: newValue });
    };

    setTabState = async () => {
        const { url } = this.state;
        await this.setState({
            currentlyActiveTab: this.getLocationIndexByStatus(url.status),
            isLoading: false,
        });
    };

    tabRender = (currentIndex) => {
        switch (currentIndex) {
            case 0:
                window.heap.track('ltoe_view_active_assignment', {
                    key: 'ltoe_view_active_assignment',
                    description: 'A user is viewing their active assignment',
                });
                window.Appcues.track('ltoe_view_active_assignment', {
                    key: 'ltoe_view_active_assignment',
                    description: 'A user is viewing their active assignment',
                });
                return (
                    <ActiveAssignmentsYourTeam
                        setAssignmentPageError={this.setAssignmentPageError}
                    />
                );
            case 1:
                window.heap.track('ltoe_view_upcoming_assignment', {
                    key: 'ltoe_view_upcoming_assignment',
                    description: 'A user is viewing their upcoming assignment',
                });
                window.Appcues.track('ltoe_view_upcoming_assignment', {
                    key: 'ltoe_view_upcoming_assignment',
                    description: 'A user is viewing their upcoming assignment',
                });
                return (
                    <UpcomingAssignmentsYourTeam
                        setAssignmentPageError={this.setAssignmentPageError}
                    />
                );
            case 2:
                return <PastAssignments setAssignmentPageError={this.setAssignmentPageError} />;
            case 3:
                window.heap.track('ltoe_view_presents', {
                    key: 'ltoe_view_presents',
                    description: 'A user is viewing their Presents',
                });
                window.Appcues.track('ltoe_view_presents', {
                    key: 'ltoe_view_presents',
                    description: 'A user is viewing their Presents',
                });
                return <PresentsList setAssignmentPageError={this.setAssignmentPageError} />;
            default:
                window.heap.track('ltoe_view_active_assignment', {
                    key: 'ltoe_view_active_assignment',
                    description: 'A user is viewing their active assignment',
                });
                window.Appcues.track('ltoe_view_active_assignment', {
                    key: 'ltoe_view_active_assignment',
                    description: 'A user is viewing their active assignment',
                });
                return (
                    <ActiveAssignmentsYourTeam
                        setAssignmentPageError={this.setAssignmentPageError}
                    />
                );
        }
    };

    render() {
        const { classes } = this.props;
        const { currentlyActiveTab, isLoading, flags } = this.state;
        if (isLoading) {
            return (
                <div className={classes.progressWrapper}>
                    <CircularProgress classes={{ root: classes.progressRoot }} color="primary" />
                </div>
            );
        }
        return (
            <div className={classes.root}>
                <ErrorDialog
                    open={!!flags.apiError}
                    onClose={this.closeError}
                    title={!flags.apiError ? null : flags.apiError.title}
                    description={!flags.apiError ? null : flags.apiError.message}
                    errorId={!flags.apiError ? null : flags.apiError.errorId}
                />
                <Container maxWidth="xl">
                    <Tabs
                        classes={{
                            indicator: classes.indicator,
                            root: classes.tabsRoot,
                            scrollable: classes.scrollableVariant,
                        }}
                        value={currentlyActiveTab}
                        onChange={this.tabChanged}
                        scrollButtons="auto"
                        variant="scrollable"
                    >
                        <Tab label="Active Assignments" />
                        <Tab label="Upcoming Assignments" />
                        <Tab label="Past Assignments" />
                        <Tab classes={{ root: classes.Tab_Root }} label="Presents" />
                    </Tabs>
                    {this.tabRender(currentlyActiveTab)}
                </Container>
            </div>
        );
    }
}

export default WithContexts(withRouter(withStyles(styles)(Assignments)));
